import { dateOfBirthSchema, isValidDocNumber } from '@/utils/schemas'
import { z } from 'zod'
import { DocType } from '../shared'
import { AssuredPersonRelationship } from './Assured'

export const assuredPeopleSchema = () => {
  return z.object({
    name: z.string().min(1, 'El nombre es requerido').max(100, 'El nombre es muy largo'),
    docType: z.enum(Object.values(DocType), { message: 'Debes seleccionar un tipo de documento' }),
    docNumber: z.string().min(1, 'El número de documento es requerido para abonados'),
    dateOfBirth: dateOfBirthSchema.nullable(),
    relationship: z.enum(Object.values(AssuredPersonRelationship), { message: 'Debes seleccionar un parentesco' }),
    // notes: z.string().optional()
  }).refine(
    (data) => isValidDocNumber(data.docType, data.docNumber), {
    message: 'El número de documento es inválido para el tipo de documento seleccionado',
    path: ['docNumber']
  })
}
